const listaDeWorkflowsRecuperacao = (state) => {
    return state.items;
}

const loadingWorkflowsRecuperacao = (state) => {
    return state.carregando
}

const paginacao = (state) => state.paginacao || null

export {
    listaDeWorkflowsRecuperacao,
    loadingWorkflowsRecuperacao,
    paginacao
}